import Vant, { Toast } from 'vant'
import Vue from 'vue'
Vue.use(Toast)

export default {
  data() {
    return {
      tempAccount: '',
      tempWithdrawType: '',
      showKeyboard: false,
      cardStatus: 0
    }
  },
  methods: {
    onPasswordSuccess() {
      this.showKeyboard = false
      setTimeout(() => this.unbindAccount(), 100)
    },
    formatAccount(account) {
      if (account) {
        const len = account.length
        if (len > 8) {
          return account.substr(0, 4) + '****' + account.substr(len - 4, len)
        } else if (len > 4) {
          return account.substr(0, 2) + '***' + account.substr(len - 2, len)
        }
        return account
      }
      return account
    },
    unbind() {
      if (this.withdrawType === 3 || this.withdrawType === 12 || (this.bankType === -2 && this.withdrawType === 16)) {
        const message =
          this.withdrawType === 3
            ? this.$t('withdrawAccount.unbindBankCardConfirmDialog', [this.formatAccount(this.$route.params.account)])
            : this.$t('withdrawAccount.unbindMobileMoneyAccountConfirmDialog', [
                this.formatAccount(this.$route.params.account)
              ])
        // 解绑银行卡
        this.$dialog
          .confirm({
            cancelButtonText: this.$t('common.cancel'),
            confirmButtonText: this.$t('common.confirm'),
            message: message
          })
          .then(() => {
            this.showKeyboard = true
            this.cardStatus = 1
            this.tempAccount = this.$route.params.account
            this.tempWithdrawType = this.$route.params.withdrawType
          })
      } else {
        // 第三方支付
        this.$dialog
          .confirm({
            cancelButtonText: this.$t('common.cancel'),
            confirmButtonText: this.$t('common.confirm'),
            message: this.$t('withdrawAccount.unbindAccountConfirmDialog', [this.formatAccount(this.account)])
          })
          .then(() => {
            this.showKeyboard = true
            this.cardStatus = 2
            this.tempAccount = this.$route.params.account
            this.tempWithdrawType = this.$route.params.withdrawType
          })
      }
    },
    unbindAccount() {
      if (this.cardStatus === 1) {
        const data = {
          account: this.tempAccount,
          withdrawType: this.tempWithdrawType,
          msgCode: '2121'
        }
        this.$http
          .post(window.serverPath + '/api/account/unBindBankCard', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              this.showKeyboard = false
              this.successBack()
            } else {
              Toast({ message: this.$t('withdrawAccount.unbindFailedToast') })
            }
          })
          .catch((err) => console.log(err))
      }
      if (this.cardStatus === 2) {
        const data = {
          account: this.tempAccount,
          withdrawType: this.tempWithdrawType,
          msgCode: '2121'
        }
        this.$http
          .post(window.serverPath + '/api/account/unbindThirdPartyPay', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              this.showKeyboard = false
              this.successBack()
            } else {
              Toast({ message: this.$t('withdrawAccount.unbindFailedToast') })
            }
          })
          .catch((err) => console.log(err))
      }
    },
    successBack() {
      this.$router.replace({
        name: 'bankcardResult',
        params: { eventId: 1 }
      })
    },
    onClose() {
      this.showKeyboard = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/linkMixins.js